import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Stack,
  ThemeProvider,
} from "@mui/material";
import muiTheme, { DIALOG_RADIUS, BUTTON_RADIUS } from "../../theme/mui/styles";
import { createVendor } from "../../api/vendors";

export const VendorsQuickCreate = ({
  addVendorToList,
  isOpen,
  onClose,
  initialName,
}) => {
  const [name, setName] = useState(initialName || "");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setName(initialName || "");
  }, [initialName]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const trimmedName = name.trim();
    if (!trimmedName) {
      setLoading(false);
      return;
    }

    createVendor({ name: trimmedName })
      .then((res) => {
        addVendorToList({
          value: res.data.id,
          label: res.data.name,
          id: res.data.id,
          name: res.data.name,
        });
        setName("");
        onClose();
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  return (
    <ThemeProvider theme={muiTheme}>
      <Dialog
        open={isOpen}
        onClose={onClose}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: { borderRadius: DIALOG_RADIUS } }}
      >
        <DialogTitle>Create Vendor</DialogTitle>
        <form id="vendorForm" onSubmit={handleSubmit}>
          <DialogContent>
            <Stack spacing={2}>
              <TextField
                label="Name"
                fullWidth
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                autoFocus
              />
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={onClose}
              disabled={loading}
              sx={{ textTransform: "none", borderRadius: `${BUTTON_RADIUS}px !important` }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              type="submit"
              form="vendorForm"
              disabled={loading || !name.trim()}
              sx={{ textTransform: "none", borderRadius: `${BUTTON_RADIUS}px !important` }}
            >
              {loading ? "Creating..." : "Create"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </ThemeProvider>
  );
};
